import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import styles from '../../styles/yachtCard.module.scss'

export const YachtCard = ({
  slug,
  image,
  altText,
  size,
  model,
  brand,
  isNew,
  status
}) => {

  const router = useRouter()
  return (
    <div className={styles.card_yacht}>
      <Image
        src={image}
        alt={altText}
        loading='lazy'
        width="359"
        height="239"
        className="object-fit-cover"
      />

      <div className={`${styles.card_description} pt-6 pb-3 px-5`}>
        <span className={styles.card_size}>
          {size[0] === "0" ? size.substring(1) : size}
          
          {isNew &&
            <span className={styles.new_indicator}>{router.locale === "es" ? " Nuevo" : " New"}</span>
          }
        </span>

        <h2 className="h4 mb-0 fw-normal">{model}</h2>

        <span className={styles.card_brand}>{brand}</span>
      </div>

      <div className="pt-5 pb-4 px-5">
        <Link href={`/yachts/${slug}`} className={styles.card_link}>
          {router.locale === "es" ? "Ver detalles" : "Show details"}
        </Link>
      </div>
      { 
        status !== "none" &&
        <div className={styles.label}>
          { status === "coming" ? router.locale === "en" ? "Incoming" : "Proximamente" : ''}
          { status === "stock" ? router.locale === "en" ? "In stock" : "Disponible" : ''}
          { status === "sold" ? router.locale === 'en' ? "Sold" : "Vendido" : ''}
          <div style={{width: '40px', height: "40px", backgroundColor: "white", position: "absolute", top: "4px", right: "-20px", transform: "rotate(45deg)"}}></div>
        </div>
      }
    </div>
  );
};
